// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"88":"browse","270":"my-favourites","499":"my-sessions","596":"404","922":"edit"}[chunkId] || chunkId) + "." + {"65":"23d87c04","88":"cef513b5","270":"4bfb3624","431":"21a51bc3","499":"54a7b930","596":"00233a86","922":"0bc94af5"}[chunkId] + ".css";
};